import moment from "moment";

export const isOverlapping = (start1, end1, start2, end2) => {
  const s1 = moment(start1, "HH:mm");
  const e1 = moment(end1, "HH:mm");
  const s2 = moment(start2, "HH:mm");
  const e2 = moment(end2, "HH:mm");

  return s1.isBefore(e2) && s2.isBefore(e1);
};
